import { targetGroups } from '@/mocks/franchiseData';
import ScrollReveal from '@/components/base/ScrollReveal';

export default function TargetGroups() {
  return (
    <section className="relative bg-white py-16 md:py-24">
      <div className="px-6 md:px-10">
        <div className="max-w-7xl mx-auto">
          <ScrollReveal variant="fade-up">
            <div className="text-center mb-14">
              <p className="text-brand-brown text-sm tracking-widest mb-3 font-medium">适合人群</p>
              <h2 className="text-3xl md:text-4xl font-bold text-brand-deep leading-tight">
                无论您的背景如何，总有一条适合的加盟路径
              </h2>
            </div>
          </ScrollReveal>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
            {targetGroups.map((group, i) => (
              <ScrollReveal key={group.title} variant="fade-up" delay={i * 100}>
                <div className="text-center p-6 md:p-8 rounded-2xl border border-brand-light/40 hover:border-brand-cream hover:shadow-md transition-all duration-300 cursor-pointer group">
                  <div className="w-14 h-14 flex items-center justify-center mx-auto mb-5 rounded-2xl bg-brand-light group-hover:bg-brand-cream transition-colors">
                    <i className={`${group.icon} text-brand-deep text-2xl`} />
                  </div>
                  <h3 className="text-base font-semibold text-brand-deep mb-3">{group.title}</h3>
                  <p className="text-gray-400 text-xs leading-relaxed">{group.desc}</p>
                </div>
              </ScrollReveal>
            ))}
          </div>

          <ScrollReveal variant="fade-up" delay={200}>
            <div className="mt-12 bg-brand-light/50 rounded-2xl p-8 md:p-12 text-center">
              <p className="text-brand-dark text-sm md:text-base leading-relaxed max-w-2xl mx-auto">
                我们欢迎不同背景的合作伙伴。只要您认可麦杰集团的品牌理念，
                愿意投入时间与精力经营一份健康事业，我们都将为您提供
                系统化、全流程的支持与陪伴。
              </p>
            </div>
          </ScrollReveal>
        </div>
      </div>
    </section>
  );
}